/**
 * Helper services/functions for making api requests.
 */

import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import toast from '../services/toast'
// import JwtService from "@/common/jwt.service"
import { APP_CONFIG } from '../config/config'

const ApiCall = {
  init() {
    Vue.use(VueAxios, axios)
    Vue.axios.defaults.baseURL = APP_CONFIG.apiUrl
  },

  query(resource, cleanParams, signal) {
    return Vue.axios({
      method: 'get',
      url: resource,
      params: cleanParams,
      signal: signal,
    }).catch((error) => {
      toast.error(error)
      throw new Error(`[RWV] ApiCall ${error}`)
    })
  },

  get(resource, slug = '') {
    return Vue.axios.get(`${resource}/${slug}`).catch((error) => {
      throw new Error(`[RWV] ApiCall ${error}`)
    })
  },
}

export default ApiCall

/**
 * Get Service data
 */
export const ServiceCall = {
  query(paramsPass, canceler) {
    // Strip -safe suffix
    let safeParams = safe_replacement(paramsPass)
    safeParams.per_page = 60

    safeParams.include = 'regular_schedules,service_taxonomys,service_areas,service_at_locations'
    return ApiCall.query('hservices/local', safeParams, canceler)
  },

  get(id) {
    return ApiCall.get('services', id)
  },
}

/**
 * Get Service data
 */
export const FilterCall = {
  query(type, params) {
    return ApiCall.query(`collections${type === 'feed' ? '/feed' : ''}`, {
      params,
    })
  },

  get(filterId) {
    const callUrl = '/taxonomies'
    const cleanParams = {}

    params.vocabulary = filterId
    params.per_page = 500
    params.root_only = true
    // Get the filter data and populate
    return ApiCall.query(callUrl, {
      params: cleanParams,
    })
  },
}

/**
 * Get Organization data
 */
export const OrganizationCall = {
  get(id) {
    return ApiCall.get('organizations', id)
  },
}

/**
 * Get Location data
 */
export const LocationCall = {
  query(paramsPass, canceler) {
    // Strip -safe suffix
    let safeParams = safe_replacement(paramsPass)
    safeParams.per_page = 60

    safeParams.include = '6service_at_locations'
    return ApiCall.query('locations', safeParams, canceler)
  },
  get(id) {
    return ApiCall.get('locations', id)
  },
}

/**
 * Favourite api calls
 */
export const FavouriteCall = {
  post(data) {
    const form_data = new FormData()
    form_data.append('action', 'api_request')

    for (var pair of Object.entries(data)) {
      form_data.append(pair[0], pair[1])
    }
    return Vue.axios
      .post(APP_CONFIG.favouriteUrl, form_data, {
        baseURL: '/',
      })
      .catch((error) => {
        toast.error(`${error}`)
        throw new Error(`[RWV] ApiCall ${error}`)
      })
  },
}

/**
 * Save search api call
 */
export const SaveSearchCall = {
  post(data) {
    const form_data = new FormData()
    form_data.append('action', 'api_request')

    for (var pair of Object.entries(data)) {
      form_data.append(pair[0], pair[1])
    }
    return Vue.axios
      .post(APP_CONFIG.favouriteUrl, form_data, {
        baseURL: '/',
      })
      .catch((error) => {
        toast.error(`${error}`)
        throw new Error(`[RWV] ApiCall ${error}`)
      })
  },
}

/**
 * Wordpress get page call
 */
export const WordpressCall = {
  get(path) {
    return Vue.axios.get(APP_CONFIG.wordpressFeedUrl).catch((error) => {
      toast.error(`${error}`)
      throw new Error(`[RWV] ApiCall ${error}`)
    })
  },
}

function safe_replacement(paramsPass) {
  // iterate over all properties
  let params = Object.assign({}, paramsPass)
  for (var name in params) {
    if (name.endsWith('-safe') === true) {
      const nameSplit = name.split('-')
      console.log(nameSplit)
      console.log(params[name])
      params[nameSplit[0]] = params[name]
      delete params[name]
    }
  }
  return params
}
